export default "__VITE_ASSET__lDHKPSsa__"